import { WeatherAdapter as CoreWeatherAdapter } from '@core/adapters';

export class WeatherAdapter extends CoreWeatherAdapter {}
